import React, { type ReactNode } from 'react';

import { FooterWrapper, Interior } from './styles';

export interface FooterProps {
    children: ReactNode;
    extraPaddingBottom?: boolean;
}

export function Footer({ children, extraPaddingBottom = false }: FooterProps) {
    return (
        <FooterWrapper>
            <Interior $extraPaddingBottom={extraPaddingBottom}>{children}</Interior>
        </FooterWrapper>
    );
}
